<template>
  <div class="addPlatform">
    <div class="addPlatform_titleArea">
      <h3 class="title">添加平台</h3>
      <i
        class="close"
        @click="$emit('close')"
      >X</i>
    </div>
    <div class="addPlatform_main">
      <ul class="main_box">
        <li class="box_item">
          <span class="item_text">name</span>
          <input
            v-model="name"
            class="item_input"
          >
        </li>
        <li class="box_item pi">
          <span class="item_text">struct</span>
          <div class="item_box">
            <div class="box_input">
              <input
                v-for="item in index"
                :key="item"
                v-model="struct[item-1]"
                class="item_input"
              >
            </div>
            <div class="myBox">
              <i
                class="box_icon"
                @click="index>=6 ? index : index++"
              >+</i>
              <i
                class="box_icon"
                @click="index<=1 ? index : index--"
              >-</i>
            </div>

          </div>
        </li>
      </ul>
    </div>
    <div class="addPlatform_buttonArea">
      <button class="button cancel">取消</button>
      <button
        class="button determine"
        @click="determine"
      >确定</button>
    </div>
  </div>
</template>

<script>
import { addPlatform } from '@/api/providerAccountManagement/servicePorviderList.js'
export default {
  props: {
    datas: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      index: 1,
      struct: [],
      name: ''
    }
  },
  methods: {
    async determine() {
      await addPlatform(this.name, this.struct)
      this.name = ''
      this.struct = []
      this.$message({
        message: '添加成功',
        type: 'success'
      })
      this.$emit('determine')
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="less">
.addPlatform {
  box-shadow: 0 0 0 1px hsl(0deg 0% 42% / 15%), 0 10px 36px 0 rgb(0 0 0 / 10%), 0 6px 15px 0 rgb(0 0 0 / 7%);
  width: 500px;
  margin: auto;
  z-index: 1;
  background-color: #fff;
  top: 50%;
  position: relative;
  transform: translateY(-50%);
  min-height: 310px;
  border-radius: 7px;
  display: flex;
  flex-direction: column;
  .addPlatform_titleArea {
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #ccc;
    .title {
    }
    .close {
      font-style: normal;
      cursor: pointer;
      &:hover {
        font-weight: bold;
      }
    }
  }

  .addPlatform_main {
    flex-grow: 1;
    .main_box {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 40px;
      height: 100%;
      .box_item {
        padding: 10px 0px;
        display: flex;
        align-items: center;
        &.pi {
          align-items: baseline;
        }
        .item_text {
          width: 55px;
          display: inline-block;
        }
        .item_input {
          width: 150px;
          border: 1px solid #ccc;
          height: 27px;
          padding-left: 10px;
          &:focus {
            border-color: #008c8c;
          }
        }
        .item_box {
          display: flex;
          position: relative;
          align-items: stretch;
          .box_input {
            display: flex;
            flex-direction: column;
            .item_input {
              margin: 5px 0px;
            }
          }
          .myBox {
            position: absolute;
            right: -61px;
            display: flex;
            top: 10px;
            .box_icon {
              font-style: normal;
              display: flex;
              width: 19px;
              height: 19px;
              border: 1px solid #ccc;
              border-radius: 50%;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              transition: all 0.3s;
              margin: 0px 4px;
              &:hover {
                font-weight: bold;
                color: #fff;
                border-color: #fff;
                background-color: black;
              }
            }
          }
        }
      }
    }
  }
  .addPlatform_buttonArea {
    padding: 10px 20px;
    border-top: 1px solid #ccc;
    display: flex;
    justify-content: center;
    .button {
      padding: 8px 20px;
      outline: none;
      margin: 0px 20px;
      cursor: pointer;
      border: none;
      border-radius: 4px;
      &.cancel {
        background-color: #fff;
        box-shadow: 0 3px 3px 0 rgb(0 0 0 / 3%), 0 0 0 1px #e0e0e0;
      }
      &.determine {
        font-weight: 500;
        color: #fff;
        background-color: #07c160;
        box-shadow: 0 0 0 1px rgb(0 0 0 / 15%), 0 2px 4px 0 rgb(0 0 0 / 10%), 0 0 0 1px #07c160;
      }
    }
  }
}
</style>
